const state = {

    scroll: 0
}

export default state
